export const formatPrice = (price) => {
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: 'HUF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatImageUrl = (url) => {
  if (!url) return '';
  
  // If it's already a full URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a relative URL starting with /api/uploads/, prepend backend URL
  if (url.startsWith('/api/uploads/')) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  
  // Legacy support for old /uploads/ URLs - convert to /api/uploads/
  if (url.startsWith('/uploads/')) {
    return `${process.env.REACT_APP_BACKEND_URL}/api${url}`;
  }
  
  // Otherwise return as is
  return url;
};

export const categoryNames = {
  witchy_box: 'Witchy Box',
  spell_jar: 'Spell Jar',
  crystal: 'Ásványok',
  digital: 'Digitális termékek',
  incense: 'Füstölők',
  cards: 'Kártyák',
  books: 'Könyvek'
};

export const orderStatusNames = {
  pending: 'Függőben',
  paid: 'Fizetve',
  processing: 'Feldolgozás alatt',
  shipped: 'Kiszállítva',
  delivered: 'Kézbesítve',
  cancelled: 'Törölve'
};

export const paymentMethodNames = {
  barion: 'Barion',
  simplepay: 'SimplePay',
  transfer: 'Banki átutalás',
  bank_transfer: 'Banki átutalás',
  stripe: 'Bankkártya (Stripe)',
  cash: 'Utánvét (készpénz)'
};

export const shippingMethodNames = {
  courier: 'Futárszolgálat',
  personal_pickup: 'Személyes átvétel'
};
